<script setup>
import { computed } from 'vue';
import { useReportFormatter } from 'dashboard/composables/useReportFormatter';

const { weekdayInitials } = useReportFormatter();

const days = computed(() => weekdayInitials());
</script>

<template>
  <div class="max-w-md mx-auto grid grid-cols-7 gap-2">
    <div
      v-for="(day, index) in days"
      :key="index"
      class="flex items-center justify-center font-medium text-sm w-9 h-7 py-1.5 px-2"
    >
      {{ day }}
    </div>
  </div>
</template>
